import type {
  AdminSetUserPasswordInput,
  AuthStateSubscriber,
  ChangePasswordInput,
  IAuthRepository,
  LoginInput,
} from '@/features/authentication/domain/repositories/IAuthRepository.js';
import type { AuthSessionEntity } from '@/features/authentication/domain/entities/AuthSessionEntity.js';
import { AuthRemoteDataSource } from '@/features/authentication/data/datasources/AuthRemoteDataSource.js';

export class AuthRepository implements IAuthRepository {
  constructor(private readonly remoteDataSource: AuthRemoteDataSource) {}

  login(input: LoginInput): Promise<AuthSessionEntity> {
    return this.remoteDataSource.login(input);
  }

  changePassword(input: ChangePasswordInput): Promise<void> {
    return this.remoteDataSource.changePassword(input);
  }

  adminSetUserPassword(input: AdminSetUserPasswordInput): Promise<void> {
    return this.remoteDataSource.adminSetUserPassword(input);
  }

  logout(): Promise<void> {
    return this.remoteDataSource.logout();
  }

  getSession(): Promise<AuthSessionEntity | null> {
    return this.remoteDataSource.getSession();
  }

  refreshSession(): Promise<AuthSessionEntity | null> {
    return this.remoteDataSource.refreshSession();
  }

  observeAuthState(subscriber: AuthStateSubscriber): () => void {
    return this.remoteDataSource.observeAuthState(subscriber);
  }
}
